<template>
    <li class="breadcrumb-item">
        <router-link :to="to" class="text-decoration-none text-black">
            {{ page }}
        </router-link>
    </li>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: 'FKBreadCrumbItem',
    props: ['page', 'to']
})
</script>